<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('product.productsWithSamePriceCode') }}
        <d-badge theme="primary">{{ samePriceCode.length }}</d-badge>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table table-sm">
        <tr
          v-for="(row, index) of samePriceCode"
          :key="'same-price-code-item-' + index">
          <td class="px-4">{{ row.name }}</td>
        </tr>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'product-same-price-products-popup',
  props: {
    samePriceCode: {
      default: () => ([]),
      type: Array
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('product-same-price-code-popup-close');
    }
  }
}
</script>
